import { createAction, props } from "@ngrx/store";

const prefix = "[Add Related Skills]";

export const requestAddRelatedSkill = createAction(
  `${prefix} Request Add Related Skill`,
  props<{ selectedSkillId: string; relatedSkillId: string }>(),
);
export const requestDeleteRelatedSkill = createAction(
  `${prefix} Request Delete Related Skill`,
  props<{ selectedSkillId: string; relatedSkillId: string }>(),
);
